export const TEXTFIELD_TYPES = {
  name: 'name',
  surname: 'surname',
  email: 'email',
};
